import { ImageSelectionModalMemo } from './ImageSelectionModal';
import { ImageToVideoPromptModalMemo } from './ImageToVideoPromptModal';
import { SceneVideoLightbox } from './SceneVideoLightbox';
import type { IPropertySceneExtended } from '@/@types/propertySceneEditor';
import type { Id } from '../../../convex/_generated/dataModel';

interface IPropertySceneEditorModalsProps {
  imageSelectionModalOpen: boolean;
  closeImageSelectionModal: () => void;
  imageSelectionScene: IPropertySceneExtended | null;
  processedImages: Id<'_storage'>[];
  aspectRatio: '16:9' | '9:16';
  handleImageSelect: (imageId: Id<'_storage'>) => Promise<void>;
  promptModalOpen: boolean;
  closePromptModal: () => void;
  promptModalScene: IPropertySceneExtended | null;
  handlePromptSave: (positivePrompt: string, negativePrompt: string) => Promise<void>;
  handlePromptSaveAndGenerate: (positivePrompt: string, negativePrompt: string) => Promise<void>;
  handleRegeneratePrompt: () => Promise<void>;
  isRegeneratingPrompt: boolean;
  lightboxOpen: boolean;
  handleCloseLightbox: () => void;
  scenes: IPropertySceneExtended[];
  lightboxSceneIndex: number;
}

export function PropertySceneEditorModals({
  imageSelectionModalOpen,
  closeImageSelectionModal,
  imageSelectionScene,
  processedImages,
  aspectRatio,
  handleImageSelect,
  promptModalOpen,
  closePromptModal,
  promptModalScene,
  handlePromptSave,
  handlePromptSaveAndGenerate,
  handleRegeneratePrompt,
  isRegeneratingPrompt,
  lightboxOpen,
  handleCloseLightbox,
  scenes,
  lightboxSceneIndex,
}: IPropertySceneEditorModalsProps) {
  return (
    <>
      <ImageSelectionModalMemo
        isOpen={imageSelectionModalOpen}
        onClose={closeImageSelectionModal}
        scene={imageSelectionScene}
        processedImages={processedImages}
        aspectRatio={aspectRatio}
        onSelect={handleImageSelect}
      />

      <ImageToVideoPromptModalMemo
        isOpen={promptModalOpen}
        onClose={closePromptModal}
        scene={promptModalScene}
        onSave={handlePromptSave}
        onSaveAndGenerate={handlePromptSaveAndGenerate}
        onRegeneratePrompt={handleRegeneratePrompt}
        isRegenerating={isRegeneratingPrompt}
      />

      <SceneVideoLightbox
        isOpen={lightboxOpen}
        onClose={handleCloseLightbox}
        scenes={scenes}
        initialSceneIndex={lightboxSceneIndex}
        aspectRatio={aspectRatio}
      />
    </>
  );
}
